<div class="overflow-clip">
  @if (artstamm) {
    <div class="image-container">
      <ng-container>
        <img [attr.src]="artstamm | loadArchiveFile | async" class="image" alt="item image">
      </ng-container>
    </div>
  }
</div>

